import { useLocation, useNavigate } from "react-router-dom";
import DataTableWrapper from "../../Utility/DataTableWrapper/DataTableWrapper";
import { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { FormUtility } from "../../Utility/FormUtility";
import { rolesCodes } from "../../../constants/Roles";
import Select from "../../Form/Select";
import Upload from "../../Form/Upload";
import ToastContext from "../../../contexts/toast";
import FiltriAvanzati from "../../Utility/FiltriAvanzati/FiltriAvanzati";
import Modal from "../../Utility/Modal/Modal";
import { BandoService } from "../../../services/BandoService";
import { ComuneService } from "../../../services/ComuneService";
import { AnprService } from "../../../services/AnprService";
import moment from "moment";

export default function GestioneAnpr() {

    const [dtOptions, setDtOptions] = useState({});
    const navigate = useNavigate();

    const [avviso, setAvviso] = useState(null);
    const [avvisi, setAvvisi] = useState([]);

    const [provincia, setProvincia] = useState(null);
    const [province, setProvince] = useState([]);

    const [comune, setComune] = useState(null);
    const [comuni, setComuni] = useState([]);


    const [currMapFilters, setCurrMapFilters] = useState(new Map());
    const [nextMapFilters, setNextMapFilters] = useState(null);
    const [advancedFiltersMap, setAdvancedFiltersMap] = useState(null);
    const [nextAdvancedFiltersMap, setNextAdvancedFiltersMap] = useState(null);

    const [firstLoad, setFirstLoad] = useState(false);

    const location = useLocation();

    const [isModalOpen, setModalOpen] = useState(false);

    const [disabledConfirmBtn, setDisabledConfirmBtn] = useState(true);

    const [title, setTitle] = useState(null);
    const [actionLabel, setActionLabel] = useState("");
    const [content, setContent] = useState(null);
    const [reportData, setReportData] = useState(null);

    const toastContext = useContext(ToastContext);

    const roles = useSelector((state) => state.role);
    const utility = new FormUtility({ data: roles });

    const bandoService = new BandoService();
    const comuneService = new ComuneService();
    const anprService = new AnprService();


    const [validazioneVisible, setValidazioneVisible] = useState(false);
    const [validazioneClass, setValidazioneClass] = useState(null);
    const [closeLabel, setCloseLabel] = useState("Annulla");
    const [spinnerVisible, setSpinnerVisible] = useState(false);
    const [disableCloseBtn, setDisableCloseBtn] = useState(false);
    const uploadRef = useRef(null);

    const dtRef = useRef();
    const rowRef = useRef(null);




    useEffect(() => {
        bandoService.getAll().then((resp) => {
            setAvvisi([...resp]);
        });

        /*comuneService.getAllProvinceByRegione("Toscana").then((resp) => {
          resp.sort((a, b) => (a.value.localeCompare(b.value)));
          setProvince(resp);
    
          const filtri = utility.getFiltriAvanzatiStorage(
            location,
            "_filtri_avanzati"
          );
          if (filtri?.Avviso) {
            onChangeFilter("Avviso", filtri.Avviso, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap));
          }
        });*/
    }, []);

    useEffect(() => {
        if (/*comuni.length === 0 ||*/ firstLoad) {
            return;
        }

        const filtri = utility.getFiltriAvanzatiStorage(
            location,
            "_filtri_avanzati"
        );
        setOnLoadFiltriAvanzatiFromStorage(filtri);
        setNextMapFilters(filtri ? new Map(Object.entries(filtri)) : new Map());
        setCurrMapFilters(filtri ? new Map(Object.entries(filtri)) : new Map());

        setFirstLoad(true);
    }, [comuni, firstLoad]);

    const setOnLoadFiltriAvanzatiFromStorage = (filtri) => {
        const filtriAvanzati = advancedFiltersMap ?? new Map();
        const proxMappaFiltri = new Map(nextMapFilters);
        const proxMappaFiltriAvanzati = new Map(nextAdvancedFiltersMap);

        for (const key in filtri) {
            const value = filtri[key];

            let filterValue = value;
            let filtroAvanzato = value;
            switch (key) {
                case "Comune":
                    filterValue = comuni.find((el) => el.denominazione === value)?.codice;
                    break;
                default:
                    break;
            }

            onChangeFilter(key, filterValue, proxMappaFiltri, proxMappaFiltriAvanzati, false);
            filtriAvanzati.set(key, filtroAvanzato);
        }

        setNextAdvancedFiltersMap(new Map(filtriAvanzati));
        setAdvancedFiltersMap(new Map(filtriAvanzati));
    };

    const handleModalAction = async () => {
        if (!rowRef.current) {
            if (!avviso)return;
            anprService.eseguiControllo(avviso).then((resp) => {
                toastContext.success('Schedulato controllo ANPR con successo');  
                dtRef.current.rerenderDatatable();   
                setModalOpen(false); 
            }).catch((error) => {
                toastContext.error(utility.getErrorMsg(error), 12000);      
            });
            return;
        }
        anprService.eseguiControlloSingolaRichiesta(rowRef.current.richiestaId).then(() => {
            rowRef.current = null;
            dtRef.current.rerenderDatatable();
            toastContext.success(
                "Controllo rischedulato con successo",
                6000
            );
            setModalOpen(false);
        })
            .catch((error) => {
                rowRef.current = null;
                toastContext.error(utility.getErrorMsg(error), 12000);
                setModalOpen(false);
            });

    };

    useEffect(() => {
        if (avviso) {
            /*comuneService
              .getAllByBandoAndTipologiaAndDenominazioneRegioneAndProvincia(
                avviso,
                "Comune",
                "Toscana",
                provincia
              )
              .then((resp) => {
                resp.sort((a, b) => (a.denominazione.localeCompare(b.denominazione)));
                setComuni([...resp]);
              });*/
        }
    }, [avviso]);

    const setFiltriAvanzatiInStorage = (mapFilters) => {
        const obj = Object.fromEntries(mapFilters);
        sessionStorage.setItem(
            `${location.pathname}_filtri_avanzati`,
            JSON.stringify(obj)
        );
    };

    const onChangeFilter = async (type, val, mappaFiltri, mappaFiltriAvanzati, updateNextMap = true, updateMap = false) => {
        let mapValue = val;
        let mapAvanzatoValue = val;

        switch (type) {
            case "Avviso":
                setAvviso(val);
                break;
            case "Comune":
                mapValue = comuni.find((e) => e.codice === val)?.denominazione;
                setComune(val);
                break;
            default:
                break;
        }

        if (!mapValue) {
            mappaFiltri.delete(type);
            mappaFiltriAvanzati.delete(type);
        } else {
            mappaFiltri.set(type, mapValue);
            mappaFiltriAvanzati.set(type, mapAvanzatoValue);
        }

        if (updateNextMap) {
            setNextMapFilters(new Map(mappaFiltri));
            setNextAdvancedFiltersMap(new Map(mappaFiltriAvanzati));
        }

        if (!updateMap) {
            return;
        }

        setCurrMapFilters(new Map(mappaFiltri));
        setAdvancedFiltersMap(new Map(mappaFiltriAvanzati));
        setFiltriAvanzatiInStorage(new Map(mappaFiltri));
    };

    useEffect(() => {
        if (!firstLoad || !currMapFilters || !avviso) {
            return;
        }

        createDtOptions();
    }, [currMapFilters]);



    const eseguiControllo = () => {
            setTitle("Controllo ANPR");
            setContent(`Sei sicuro di voler eseguire il controllo ANPR sulle richieste non verificate?`);
            setActionLabel("Conferma");
            setModalOpen(true);
            setDisabledConfirmBtn(false);
            rowRef.current = null;
        
    };

    const creaCampione = () => {
        if (!avviso) return;
        anprService.creaCampione(avviso).then((resp) => {
            toastContext.success('Campione ANPR creato con successo');
            dtRef.current.rerenderDatatable();
        }).catch((error) => {
            toastContext.error(utility.getErrorMsg(error), 12000);
        });
    };

    const eseguiControlloSingolaRiga = (row) => {
        setTitle("Controllo ANPR singola pratica");
        setContent(`Sei sicuro di voler eseguire il controllo ANPR sulla richiesta ${row.codice}?`);
        setActionLabel("Conferma");
        setModalOpen(true);
        setDisabledConfirmBtn(false);
        rowRef.current = row;
    }



    const createDtOptions = () => {
        const dtOpt = {
            columns: [
                {
                    name: "id",
                    data: "richiestaId",
                    visible: false,
                    sortable: false,
                    searchable: true,
                },
                {
                    name: "Codice pratica",
                    data: "codice",
                    visible: true,
                    sortable: true,
                    searchable: true,
                },
                {
                    name: "Codice fiscale",
                    data: "codiceFiscale",
                    visible: true,
                    sortable: true,
                    searchable: true,
                },
                {
                    name: "Comune da verificare",
                    data: "comuneDaVerificare",
                    visible: true,
                    sortable: true,
                    searchable: true,
                },
                {
                    name: "Comune risultato",
                    data: "comuneRisultato",
                    visible: true,
                    sortable: true,
                    searchable: true,
                },
                {
                    name: "Verificato",
                    data: "verificato",
                    visible: true,
                    sortable: true,
                    searchable: true,
                    cell: (row, col) =>
                        row.verificato ? "Si" : "No",
                },
                {
                    name: "Data verifica",
                    data: "dataVerifica",
                    visible: true,
                    sortable: true,
                    searchable: true,
                    cell: (row, col) => (
                        <>
                            <div className="rtds-justify-between rtds-flex">
                                <span className="lg:rtds-hidden rtds-font-semibold">
                                    {col.name}
                                </span>
                                {
                                    row.dataVerifica ? moment(row.dataVerifica).format("DD/MM/YYYY HH:mm:ss") : ""
                                }
                            </div>
                        </>
                    )
                },
                {
                    name: "Esito servizio",
                    data: "esitoServizio",
                    visible: true,
                    sortable: true,
                    searchable: true,
                },
                {
                    name: "Esito",
                    data: "esito",
                    visible: true,
                    sortable: true,
                    searchable: true,
                    cell: (row, col) => {
                        let iconName = '';
                        switch (row.esito) {
                            case 'NON_TROVATO':
                                iconName = 'solid--exclamation-triangle ';
                                break;
                            case 'NON_RESIDENTE_TOSCANA':
                                iconName = 'solid--x-mark ';
                                break;
                            case 'RESIDENTE_TOSCANA_COMUNE_DIVERSO':
                                iconName = 'solid--exclamation-circle ';
                                break;
                            case 'RESIDENTE_TOSCANA':
                                iconName = 'solid--check ';
                                break;
                            default:
                                iconName = 'solid--minus';
                                break;

                        }
                        let buttonClassName = 'rtds-btn rtds-btn--icon ';
                        switch (row.esito) {
                            case 'NON_TROVATO':
                                buttonClassName += 'rtds-btn--warn ';
                                break;
                            case 'NON_RESIDENTE_TOSCANA':
                                buttonClassName += 'rtds-btn--danger ';
                                break;
                            case 'RESIDENTE_TOSCANA_COMUNE_DIVERSO':
                                buttonClassName += 'rtds-btn--success ';
                                break;
                            case 'RESIDENTE_TOSCANA':
                                buttonClassName += 'rtds-btn--success ';
                                break;
                            default:
                                buttonClassName += 'rtds-button-inverted';
                                break;

                        }
                        return (
                            <div
                                className="rtds-justify-between rtds-flex rtds-items-center"
                            >
                                <span className="lg:rtds-hidden rtds-font-semibold">
                                    {col.name}
                                </span>
                                <button

                                    type="button"
                                    className={buttonClassName}
                                    title={row.esito}
                                >
                                    <svg
                                        className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6`}
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                    >
                                        <use
                                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${iconName}`}
                                        ></use>
                                    </svg>
                                    <span className="rtds-sr-only">{row.esito}</span>
                                </button>
                            </div>
                        );
                    }
                },
                {
                    name: "Identificativo ANPR ",
                    data: "identificativoAnpr",
                    visible: true,
                    sortable: true,
                    searchable: true,
                },
                {
                    name: "Azioni",
                    data: null,
                    visible: true,
                    sortable: false,
                    searchable: false,
                    center: true,
                    cell: (row, col) => (
                        <div
                            className="rtds-inline-flex rtds-gap-1"
                            role="group"
                            aria-label="Azioni"
                        >
                            <button
                                type="button"
                                className="rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button"
                                title={row.verificato?"Esegui nuovamente":"Esegui"}
                                onClick={() => eseguiControlloSingolaRiga(row)}
                            >
                                <svg
                                    className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                                    aria-hidden="true"
                                    focusable="false"
                                    role="img"
                                >
                                    <use
                                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--pencil-square`}
                                    />
                                </svg>
                                {row.verificato?"Esegui nuovamente":"Esegui"}
                            </button>{" "}
                        </div>
                    ),
                }
            ],
            serverSide: true,
            ajax: anprService.getAllDt,
            ajaxParams: {
                bandoId: avviso
            },
            rows: [
            ],
            sorts: [],
            hideSearch: false,
            title: "Elenco ANPR",
        };
        setDtOptions(dtOpt);
    };


    const onCloseModal = async () => {
        setModalOpen(false);
        setDisabledConfirmBtn(true);
        setReportData([]);
        rowRef.current = null;
    };


    return (
        <>
            <div className="rtds-container rtds-py-6">
                <div className="rtds-grid rtds-gap-6 xl:rtds-gap-8">
                    <div className="rtds-flex rtds-items-center rtds-justify-between">
                        <h1 className="rtds-heading-2">Gestione ANPR</h1>
                    </div>
                    <Select
                        classDiv={"rtds-mt-0 lg:rtds-mt-0"}
                        label={"Avviso"}
                        id={"avviso"}
                        classSelect={""}
                        onChange={(event) => {
                            onChangeFilter("Avviso", event.target.value ? event.target.value : null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap), true, true);
                        }}
                        baseOption={"Nessuna selezione"}
                        bindKey={"id"}
                        bindValue={"nome"}
                        options={avvisi}
                        value={avviso || ""}
                    />
                </div>
            </div>
            {avviso && (
                <DataTableWrapper
                    ref={dtRef}
                    dtOptions={dtOptions}
                    headerButton={
                        <>
                            <div className="rtds-flex rtds-gap-4 rtds-items-center rtds-flex-wrap">
                                <button
                                    type="button"
                                    className="rtds-btn--primary rtds-btn  rtds-group/button"
                                    onClick={creaCampione}

                                >
                                    Crea campione ANPR
                                </button>

                                <button
                                    type="button"
                                    className="rtds-btn--primary rtds-btn  rtds-group/button"
                                    onClick={eseguiControllo}

                                >
                                    Esegui controllo ANPR
                                </button>
                            </div>
                        </>
                    }
                />
            )}

            <Modal
                isOpen={isModalOpen}
                title={title}
                content={content}
                innerContent={``}
                onClose={() => onCloseModal()}
                onAction={handleModalAction}
                actionLabel={actionLabel}
                closeLabel={closeLabel}
                disabledConfirmBtn={disabledConfirmBtn}
                disableCloseBtn={disableCloseBtn}
                confirmLoading={spinnerVisible}
            >               
            </Modal>
        </>
    );
}
